<template>
    <v-card>
        <v-dialog v-model="message.status" width="500">
            <v-alert
                    class="mx-auto my-12"
                    max-width="500"
                    v-model="message.status"
                    dismissible
                    prominent
                    :type="message.color"
            >{{ message.text }}
            </v-alert>
        </v-dialog>
        <v-card-title>ویرایش قبض</v-card-title>
        <v-card-text>
            <v-row>
                <v-col cols="12" v-if="page.headerSidebar.widget.length>0">
                    <v-row>
                        <page-render
                                :widgets="page.headerSidebar.widget"
                                editOrShowTarget="bill"
                                @get-page="get_page"
                                @filter-page="get_page"
                                @on-pagination="onPagination"
                                :paramId="this.$route.params.id"
                                :requestApiUrl="this.page.requestApiUrl"
                        />
                    </v-row>
                </v-col>
                <v-col cols="2" sm="12" md="12" lg="3" xl="2" v-if="page.rightSidebar.widget.length>0">
                    <v-row>
                        <page-render
                                :widgets="page.rightSidebar.widget"
                                editOrShowTarget="bill"
                                @get-page="get_page"
                                @filter-page="get_page"
                                @on-pagination="onPagination"
                                :paramId="this.$route.params.id"
                                :requestApiUrl="this.page.requestApiUrl"
                        />
                    </v-row>
                </v-col>
                <v-col :cols="mainContentSize.size" sm="12" :md="mainContentSize.sizeMd" :lg="mainContentSize.sizeLg"
                       :xl="mainContentSize.sizeXl">
                    <v-row>
                        <page-render
                                :widgets="page.content.widget"
                                editOrShowTarget="bill"
                                @get-page="get_page"
                                @filter-page="get_page"
                                @on-pagination="onPagination"
                                :paramId="this.$route.params.id"
                                :requestApiUrl="this.page.requestApiUrl"
                        />
                    </v-row>
                </v-col>
                <v-col cols="2" sm="12" md="12" lg="3" xl="2" v-if="page.leftSidebar.widget.length>0">
                    <v-row>
                        <page-render
                                :widgets="page.leftSidebar.widget"
                                editOrShowTarget="bill"
                                @get-page="get_page"
                                @filter-page="get_page"
                                @on-pagination="onPagination"
                                :paramId="this.$route.params.id"
                                :requestApiUrl="this.page.requestApiUrl"
                        />
                    </v-row>
                </v-col>
                <v-col cols="12" v-if="page.footerSidebar.widget.length>0">
                    <v-row>
                        <page-render
                                :widgets="page.footerSidebar.widget"
                                editOrShowTarget="bill"
                                @get-page="get_page"
                                @filter-page="get_page"
                                @on-pagination="onPagination"
                                :paramId="this.$route.params.id"
                                :requestApiUrl="this.page.requestApiUrl"
                        />
                    </v-row>
                </v-col>
            </v-row>
        </v-card-text>
        <v-footer>{{ page.content.copyright }}</v-footer>
    </v-card>
</template>

<script>
    // eslint-disable-next-line import/extensions
    import axios from '@axios'
    import moment from 'jalali-moment'
    import router from "@/router";
    import baseConfig from '@/../baseConfig'
    import store from '@/store'
    import PageRender from '@/views/generator/page-render';
    import {tableDateHandler,formConfig,tablePaginationHandler,initialSidebarsSize,editOrShowHandler,initGroups}
        from "@/views/generator/page-handler";

    export default {
        components: {
            PageRender
        },
        data() {
            return {
                baseUrlRaw: baseConfig.basUrlRaw,
                editorConfig: {
                    automatic_uploads: true,
                    images_upload_url: baseConfig.baseUrl+"ticket/temp/image",
                    selector: 'textarea#full-featured',
                    plugins: 'preview  importcss  directionality visualblocks visualchars fullscreen image link template codesample table charmap pagebreak nonbreaking anchor insertdatetime advlist lists  wordcount  help charmap quickbars emoticons',
                    mobile: {
                        plugins: 'preview  casechange importcss tinydrive searchreplace autolink autosave save directionality advcode visualblocks visualchars fullscreen image link template codesample table charmap pagebreak nonbreaking anchor insertdatetime advlist lists  wordcount ' +
                            ' help charmap quickbars emoticons'
                    },
                    toolbar: 'undo redo | bold italic underline strikethrough | fontfamily fontsize blocks | alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist  | forecolor backcolor casechange removeformat | pagebreak | charmap emoticons | fullscreen  preview save print | insertfile image media template link anchor codesample | ltr rtl | showcomments addcomment',
                    importcss_append: true,
                    height: 300,
                    image_caption: true,
                    quickbars_selection_toolbar: 'bold italic | quicklink h2 h3 blockquote quickimage quicktable',
                    noneditable_class: 'mceNonEditable',
                    toolbar_mode: 'sliding',
                    content_style: '.mymention{ color: gray; }',
                    skin: 'oxide-dark',
                    content_css:'dark',
                    file_picker_types: 'image',
                    /* and here's our custom image picker*/
                    images_upload_base_path: '',
                    file_picker_callback: function (cb, value, meta) {
                        var input = document.createElement('input');
                        input.setAttribute('type', 'file');
                        input.setAttribute('accept', 'image/*');
                        input.onchange = async function () {
                            var file = this.files[0];
                            let body = new FormData();
                            body.append("image",file)
                            await axios.post(baseConfig.baseUrl+"ticket/temp/image", body).then(r => {
                                console.log(r);
                                store.dispatch('temp/setTemp', r.data.data).then(()=>{

                                })
                                cb(r.data.data, { title: file.name });
                            })
                            var reader = new FileReader();
                            reader.readAsDataURL(file);
                        };

                        input.click();
                    },
                },
                temp: [],
                mainContentSize: {
                    size: 12,
                    sizeSm: 12,
                    sizeMd: 12,
                    sizeLg: 12,
                    sizeXl: 12,
                },
                message: {
                    status: false,
                    text: "success operation",
                    color: "success"
                },
                page: {
                    content: {},
                    headerSidebar: {
                        widget: []
                    },
                    leftSidebar: {
                        widget: []
                    },
                    rightSidebar: {
                        widget: []
                    },
                    footerSidebar: {
                        widget: []
                    },
                },
                pagination: [],
                paginationToQueryString: "?",
                deleteUrl: "",
                record: ""
            }
        },
        beforeCreate() {
            /*if (localStorage.getItem("accessToken") === "undefined" || localStorage.getItem("accessToken") === undefined || localStorage.getItem("accessToken") === "null" || localStorage.getItem("accessToken") === null || localStorage.getItem("accessToken") === "") {
                router.push('/login')
            }*/
        },
        mounted() {
            this.get_page()
        },
        methods: {
            //dynamic ddl from request here
            async onPagination(name, current,filter) {
                this.pagination.find(p => p.table == name).page = current
                this.paginationToQueryString = "?"
                this.pagination.map(p => this.paginationToQueryString += p.table + "=" + p.page + "&")
                if (filter.id===0)
                    this.get_page()
                else {
                    await axios.post(filter.action + this.paginationToQueryString, filter.body).then(r => {
                        this.get_page(r.data.data.page)
                    })
                }
            },
            initing(){
                this.page.content.widget = formConfig(this.page.content.widget)
                this.page.leftSidebar.widget = formConfig(this.page.leftSidebar.widget)
                this.page.rightSidebar.widget = formConfig(this.page.rightSidebar.widget)
                this.page.headerSidebar.widget = formConfig(this.page.headerSidebar.widget)
                this.page.footerSidebar.widget = formConfig(this.page.footerSidebar.widget)

                this.page.content.widget = tableDateHandler(this.page.content.widget)
                this.page.leftSidebar.widget = tableDateHandler(this.page.leftSidebar.widget)
                this.page.rightSidebar.widget = tableDateHandler(this.page.rightSidebar.widget)
                this.page.headerSidebar.widget = tableDateHandler(this.page.headerSidebar.widget)
                this.page.footerSidebar.widget = tableDateHandler(this.page.footerSidebar.widget)

                this.page.content.widget=initGroups(this.page.content.widget)
                this.page.leftSidebar.widget=initGroups(this.page.leftSidebar.widget)
                this.page.rightSidebar.widget=initGroups(this.page.rightSidebar.widget)
                this.page.headerSidebar.widget=initGroups(this.page.headerSidebar.widget)
                this.page.footerSidebar.widget=initGroups(this.page.footerSidebar.widget)
            },
            async get_page(getFilteredData=null) {
                if (getFilteredData===null){
                    try {
                        await axios.get(baseConfig.baseUrl + 'bill/' + this.$route.params.id + "/edit"  + this.paginationToQueryString).then(r => {
                            if (r.data.status!=="error") {
                                this.page = r.data.data.page
                                this.initing()
                                document.title = this.page.name + ' bill'.split('/')[0]
                                if (this.paginationToQueryString === "?") {
                                    this.pagination = tablePaginationHandler(this.page.content.widget, this.page.leftSidebar.widget, this.page.rightSidebar.widget, this.page.headerSidebar.widget, this.page.footerSidebar.widget)
                                    this.paginationToQueryString = "?"
                                    this.pagination.map(p => this.paginationToQueryString += p.table + "=" + p.page + "&")
                                }

                                //goTo("#" + 'bill'.split("/")[0])
                                let result = editOrShowHandler(this.$route.params.id, 'bill', this.page)
                                this.page = result.page
                                this.record = result.record
                                this.imageFormUrl = result.imageFormUrl

                                this.mainContentSize = initialSidebarsSize(this.page)
                            }else {
                                this.message.status=true
                                this.message.text=r.data.message
                                this.message.color="error"
                                setTimeout(() => {
                                    this.message.status = false
                                }, 30000)
                            }
                            this.page.content.widget.map(w=>{
                                if (w.type==='form' && typeof w.data.valid!=='undefined'){
                                    let disableValidation=true
                                    w.data.elements.map(e => e.type!=='dropdown' & e.validations.length!==0 ? disableValidation=false : null)
                                    if (disableValidation)
                                        w.data.valid=disableValidation
                                }
                            })
                        })
                    }
                    catch(err) {
                        if(err.response.status===401)
                            await this.$router.push('/login')
                        if(err.response.status===503) {
                            this.message = {
                                status: true,
                                text: "وبسایت در دست تعمیرات است",
                                color: "red"
                            }
                        }
                    }
                }
                else{
                    this.page = getFilteredData
                    this.initing()
                    document.title = this.page.name + ' bill'.split('/')[0]
                    if (this.paginationToQueryString === "?") {
                        this.pagination = tablePaginationHandler(this.page.content.widget, this.page.leftSidebar.widget, this.page.rightSidebar.widget, this.page.headerSidebar.widget, this.page.footerSidebar.widget)
                        this.paginationToQueryString = "?"
                        this.pagination.map(p => this.paginationToQueryString += p.table + "=" + p.page + "&")
                    }

                    //goTo("#" + 'bill'.split("/")[0])
                    let result = editOrShowHandler(this.$route.params.id,'bill',this.page)
                    this.page=result.page
                    this.record=result.record
                    this.imageFormUrl=result.imageFormUrl

                    this.mainContentSize = initialSidebarsSize(this.page)
                }

            },
        },
    }
</script>

<style>
    .v-alert {
        position: fixed !important;
        left: 50% !important;;
        transform: translate(-50%, -50%) !important;;
        margin: 0 auto !important;;
        z-index: 9999 !important;
    }

</style>
